const actions = {
  enviarResposta: async (
    context,
    { autTipo, autValor, resposta, equipamento, justificativa }
  ) => {
    const api = context.rootState.autenticacao.api;

    let res = await api.post(`/cse/resposta`, {
      autTipo,
      autValor,
      resposta,
      equipamento,
      justificativa,
    });

    return res;
  },

  getHistorico: async (context) => {
    const api = context.rootState.autenticacao.api;

    let res = await api.get(`/cse/resposta/usuario`);

    return res;
  },
  getHistoricoAdm: async (context) => {
    const api = context.rootState.autenticacao.api;

    let res = await api.get(`/cse/resposta`);

    return res;
  },
  getPaginationAdm: async (context, { page, perPage }) => {
    const api = context.rootState.autenticacao.api;

    let res = await api.get(`/cse/resposta`, {
      params: {
        perPage: perPage,
        page,
      },
    });

    return res;
  },
  getFiltroAdm: async (
    context,
    {
      page,
      perPage,
      usuarioNome,

      resposta,
      dataHoraInicio,
    }
  ) => {
    const api = context.rootState.autenticacao.api;

    if (resposta == "Pessimo") {
      resposta = 1;
    } else if (resposta == "Ruim") {
      resposta = 2;
    } else if (resposta == "Regular") {
      resposta = 3;
    } else if (resposta == "Bem") {
      resposta = 4;
    } else if (resposta == "Otimo") {
      resposta = 5;
    } else if (resposta == "Todos") {
      resposta = "";
    }

    let res = await api.get(`/cse/resposta`, {
      params: {
        perPage: perPage,
        page,
        resposta,
        usuarioNome,

        dataHoraInicio,
      },
    });

    return res;
  },
  sendComentario: async (context, { respostaId, observacao }) => {
    const api = context.rootState.autenticacao.api;

    let res = await api.put(`/cse/resposta/${respostaId}/observacao`, {
      observacao,
    });

    return res;
  },
  setAlerta: async (context, { matricula, unidadeId, nivelMax }) => {
    const api = context.rootState.autenticacao.api;

    let res = await api.post(`/cse/alerta`, {
      matricula,
      unidadeId,
      nivelMax,
    });

    return res;
  },
  getAlerta: async (context, { matricula }) => {
    const api = context.rootState.autenticacao.api;

    let res = await api.get(`/cse/alerta`, {
      params: {
        matricula,
      },
    });

    return res;
  },
};

export const cse = {
  namespaced: true,
  actions,
};
